// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Slate + orange, shadcn-style skin for antd 4 (see docs/ADMIN_DESIGN_GUIDE.md).
  antd 4 is not token driven, so control heights and radii are set explicitly here.
  Default-size controls are 36px; -sm / -lg variants keep their own sizes.
*/

body {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  font-feature-settings: 'cv11', 'ss01';
  letter-spacing: -0.006em;
  color: #334155;
  background-color: #f1f5f9;
}

h1,
h2,
h3,
h4,
h5,
.ant-typography h1,
.ant-typography h2,
.ant-typography h3 {
  color: #0f172a;
  letter-spacing: -0.02em;
  font-weight: 600;
}

/* ---------- Buttons ---------- */
.ant-btn {
  font-weight: 500;
  border-radius: 8px;
  box-shadow: none;
  text-shadow: none;
}

.ant-btn:not(.ant-btn-sm):not(.ant-btn-lg) {
  height: 36px;
  padding: 4px 16px;
}

.ant-btn-icon-only:not(.ant-btn-sm):not(.ant-btn-lg) {
  width: 36px;
  padding: 0;
}

.ant-btn-round {
  border-radius: 36px;
}

.ant-btn-circle {
  border-radius: 50%;
}

.ant-btn-default:not([disabled]),
.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-ghost):not([disabled]) {
  color: #0f172a;
  background: #ffffff;
  border-color: #d6dee8;
}

.ant-btn-default:not([disabled]):hover,
.ant-btn-default:not([disabled]):focus,
.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-ghost):not([disabled]):hover,
.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-ghost):not([disabled]):focus {
  color: #0f172a;
  background: #f1f5f9;
  border-color: #d6dee8;
}

/* Primary action = orange call to action */
.ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-background-ghost):not([disabled]) {
  color: #ffffff;
  background: #f97316;
  border-color: #f97316;
}

.ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):hover,
.ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):focus {
  color: #ffffff;
  background: #ea580c;
  border-color: #ea580c;
}

.ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):active {
  background: #c2410c;
  border-color: #c2410c;
}

.ant-btn-primary[disabled],
.ant-btn-primary[disabled]:hover,
.ant-btn-primary[disabled]:focus {
  color: #ffffff;
  background: #fed7aa;
  border-color: #fed7aa;
}

.ant-btn-dangerous.ant-btn-primary {
  color: #ffffff;
  background: #ef4444;
  border-color: #ef4444;
}

.ant-btn-dangerous.ant-btn-primary:hover,
.ant-btn-dangerous.ant-btn-primary:focus {
  background: #dc2626;
  border-color: #dc2626;
}

/* ---------- Inputs ---------- */
.ant-input,
.ant-input-affix-wrapper,
.ant-picker,
.ant-input-number,
.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-color: #d6dee8;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(15, 23, 42, 0.04);
}

.ant-input:not(.ant-input-sm):not(.ant-input-lg):not(textarea) {
  height: 36px;
}

.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-sm):not(.ant-input-affix-wrapper-lg):not(.ant-input-textarea-affix-wrapper) {
  min-height: 36px;
  padding-top: 0;
  padding-bottom: 0;
}

.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-sm):not(.ant-input-affix-wrapper-lg):not(.ant-input-textarea-affix-wrapper) > input.ant-input {
  height: 34px;
}

.ant-picker:not(.ant-picker-small):not(.ant-picker-large) {
  height: 36px;
}

.ant-input-number:not(.ant-input-number-sm):not(.ant-input-number-lg) {
  height: 36px;
}

.ant-input-number:not(.ant-input-number-sm):not(.ant-input-number-lg) .ant-input-number-input {
  height: 34px;
}

.ant-select:not(.ant-select-sm):not(.ant-select-lg):not(.ant-select-customize-input) .ant-select-selector {
  min-height: 36px;
}

.ant-select-single:not(.ant-select-sm):not(.ant-select-lg):not(.ant-select-customize-input) .ant-select-selector {
  height: 36px;
}

.ant-select-single:not(.ant-select-sm):not(.ant-select-lg) .ant-select-selection-item,
.ant-select-single:not(.ant-select-sm):not(.ant-select-lg) .ant-select-selection-placeholder {
  line-height: 34px;
}

.ant-select-single:not(.ant-select-sm):not(.ant-select-lg):not(.ant-select-customize-input) .ant-select-selection-search-input {
  height: 34px;
}

.ant-input-search:not(.ant-input-search-small):not(.ant-input-search-large) .ant-input-search-button {
  height: 36px;
}

.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {
  border-radius: 0 8px 8px 0;
}

.ant-input::placeholder,
.ant-input-affix-wrapper input::placeholder {
  color: #94a3b8;
}

.ant-input:focus,
.ant-input-focused,
.ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-focused,
.ant-input-number-focused,
.ant-picker-focused,
.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
  border-color: #64748b;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.2);
}

/* ---------- Cards ---------- */
.ant-card {
  border-radius: 12px;
  box-shadow: 0 1px 2px 0 rgba(15, 23, 42, 0.05);
}

.ant-card-bordered {
  border-color: #d6dee8;
}

.ant-card-head {
  min-height: 52px;
  border-bottom-color: #d6dee8;
}

.ant-card-head-title {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.01em;
  color: #0f172a;
}

.ant-statistic-title {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
}

.ant-statistic-content {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #0f172a;
}

/* ---------- Tables ---------- */
.ant-table {
  color: #334155;
}

.ant-table-thead > tr > th {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #64748b;
  background: #fbfcfd;
  border-bottom: 1px solid #d6dee8;
}

.ant-table-thead > tr > th::before {
  display: none;
}

.ant-table-tbody > tr > td {
  border-bottom: 1px solid #e9eef4;
}

.ant-table-bordered .ant-table-thead > tr > th,
.ant-table-bordered .ant-table-tbody > tr > td,
.ant-table-bordered .ant-table-container,
.ant-table-bordered .ant-table-summary > tr > td {
  border-color: #d6dee8;
}

.ant-table-small .ant-table-thead > tr > th,
.ant-table-small .ant-table-tbody > tr > td {
  padding: 10px 12px;
}

.ant-table-tbody > tr.ant-table-row:hover > td,
.ant-table-tbody > tr > td.ant-table-cell-row-hover {
  background: #f8fafc;
}

.ant-table-tbody > tr.ant-table-row-selected > td {
  background: #e9eef4;
}

.ant-table-tbody > tr.ant-table-row-selected:hover > td {
  background: #d6dee8;
}

.ant-table-container {
  border-radius: 10px 10px 0 0;
}

/* ---------- Tags ---------- */
.ant-tag {
  padding: 0 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  border-radius: 4px;
}

.ant-tag:not([class*='ant-tag-']) {
  color: #0f172a;
  background: #d6dee8;
  border-color: transparent;
}

.ant-tag-green,
.ant-tag-success {
  color: #15803d;
  background: #f0fdf4;
  border-color: #bbf7d0;
}

.ant-tag-red,
.ant-tag-error {
  color: #b91c1c;
  background: #fee2e2;
  border-color: #fecaca;
}

.ant-tag-orange,
.ant-tag-gold,
.ant-tag-warning {
  color: #c2410c;
  background: #ffedd5;
  border-color: #fed7aa;
}

.ant-tag-blue,
.ant-tag-geekblue,
.ant-tag-processing {
  color: #0f172a;
  background: #d6dee8;
  border-color: transparent;
}

/* ---------- Alerts ---------- */
.ant-alert {
  border-radius: 8px;
}

.ant-alert-info {
  color: #334155;
  background: #fbfcfd;
  border-color: #d6dee8;
}

.ant-alert-info .ant-alert-icon {
  color: #1e293b;
}

.ant-alert-message {
  font-weight: 600;
  color: #0f172a;
}

/* ---------- Dropdowns / select options ---------- */
.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
  font-weight: 600;
  color: #0f172a;
  background: #e9eef4;
}

.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background: #f1f5f9;
}

.ant-dropdown-menu,
.ant-select-dropdown,
.ant-picker-dropdown .ant-picker-panel-container {
  border-radius: 10px;
  box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.1), 0 2px 4px -2px rgba(15, 23, 42, 0.1);
}

/* ---------- Pagination ---------- */
.ant-pagination-item,
.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
  border-radius: 8px;
}

.ant-pagination-item-active {
  background: #ffffff;
  border-color: #1e293b;
}

.ant-pagination-item-active a {
  color: #1e293b;
}

/* ---------- Modals ---------- */
@media (min-width: 577px) {
  .ant-modal:not(.ant-modal-confirm) {
    min-width: 520px;
    max-width: calc(100vw - 32px);
  }
}

/* Outer ring instead of a border, and clip children to the rounded corners so a full-bleed
   header leaves no light edge. */
.ant-modal-content {
  overflow: hidden;
  background: #e9eef4;
  border: 0;
  border-radius: 12px;
  box-shadow: 0 0 0 1px #d6dee8, 0 4px 6px -1px rgba(15, 23, 42, 0.1),
    0 2px 4px -2px rgba(15, 23, 42, 0.1);
}

.ant-modal-header {
  background: transparent;
  border-bottom: 0;
  border-radius: 12px 12px 0 0;
}

.ant-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}

.ant-modal-body {
  max-height: calc(100vh - 220px);
  overflow-x: hidden;
  overflow-y: auto;
}

.ant-modal-footer {
  padding: 12px 24px 20px;
  border-top: 0;
}

.ant-modal .ant-modal-footer .ant-btn:not(.ant-btn-sm):not(.ant-btn-lg),
.ant-modal .ant-modal-confirm-btns .ant-btn:not(.ant-btn-sm):not(.ant-btn-lg) {
  height: 40px;
  padding: 0 24px;
  font-weight: 500;
  border-radius: 8px;
}

.ant-modal .ant-modal-footer .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]),
.ant-modal .ant-modal-confirm-btns .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]) {
  background: #1e293b;
  border-color: #1e293b;
}

.ant-modal .ant-modal-footer .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):hover,
.ant-modal .ant-modal-footer .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):focus,
.ant-modal .ant-modal-confirm-btns .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):hover,
.ant-modal .ant-modal-confirm-btns .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):focus {
  background: #334155;
  border-color: #334155;
}

.ant-modal-confirm .ant-modal-content {
  background: #ffffff;
}

/* Dark hero header (see ModalHeroComponent): the hero fills the header, so drop its padding. */
.modal-dark-header .ant-modal-header {
  padding: 0;
  background: transparent;
}

.modal-dark-header .ant-modal-close {
  color: rgba(255, 255, 255, 0.85);
}

.modal-dark-header .ant-modal-close:hover {
  color: #ffffff;
}

.modal-dark-header .ant-modal-close-x {
  width: 64px;
  height: 64px;
  line-height: 64px;
}

.modal-hero {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 56px 24px 24px;
  color: #ffffff;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
}

.modal-hero-icon {
  display: flex;
  padding: 12px;
  font-size: 28px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.modal-hero-title {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.3px;
}

.modal-hero-subtitle {
  margin-top: 2px;
  font-size: 13px;
  opacity: 0.85;
}

.modal-card {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #d6dee8;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.03);
}

/* ---------- Drawer ---------- */
.ant-drawer-content {
  border-left: 1px solid #d6dee8;
}

.ant-drawer-header {
  border-bottom-color: #d6dee8;
}

.ant-drawer-title {
  font-weight: 600;
  color: #0f172a;
}
`, "",{"version":3,"sources":["webpack://./src/theme/shadcn.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;EACE;uCACqC;EACrC,qCAAqC;EACrC,wBAAwB;EACxB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;;;;;EAKE,qBAAqB;EACrB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;;;;EAOE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;EACnB,sFAAsF;AACxF;;AAEA,qCAAqC;AACrC;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;AACF;;AAEA;iCACiC;AACjC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB;wCACsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;EAIE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+FAA+F;AAC/F;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;EACf,cAAc;EACd,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,iCAAiC;AACjC;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/*\n  Slate + orange, shadcn-style skin for antd 4 (see docs/ADMIN_DESIGN_GUIDE.md).\n  antd 4 is not token driven, so control heights and radii are set explicitly here.\n  Default-size controls are 36px; -sm / -lg variants keep their own sizes.\n*/\n\nbody {\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto,\n    'Helvetica Neue', Arial, sans-serif;\n  font-feature-settings: 'cv11', 'ss01';\n  letter-spacing: -0.006em;\n  color: #334155;\n  background-color: #f1f5f9;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\n.ant-typography h1,\n.ant-typography h2,\n.ant-typography h3 {\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  font-weight: 600;\n}\n\n/* ---------- Buttons ---------- */\n.ant-btn {\n  font-weight: 500;\n  border-radius: 8px;\n  box-shadow: none;\n  text-shadow: none;\n}\n\n.ant-btn:not(.ant-btn-sm):not(.ant-btn-lg) {\n  height: 36px;\n  padding: 4px 16px;\n}\n\n.ant-btn-icon-only:not(.ant-btn-sm):not(.ant-btn-lg) {\n  width: 36px;\n  padding: 0;\n}\n\n.ant-btn-round {\n  border-radius: 36px;\n}\n\n.ant-btn-circle {\n  border-radius: 50%;\n}\n\n.ant-btn-default:not([disabled]),\n.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-ghost):not([disabled]) {\n  color: #0f172a;\n  background: #ffffff;\n  border-color: #d6dee8;\n}\n\n.ant-btn-default:not([disabled]):hover,\n.ant-btn-default:not([disabled]):focus,\n.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-ghost):not([disabled]):hover,\n.ant-btn:not(.ant-btn-primary):not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-ghost):not([disabled]):focus {\n  color: #0f172a;\n  background: #f1f5f9;\n  border-color: #d6dee8;\n}\n\n/* Primary action = orange call to action */\n.ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-link):not(.ant-btn-text):not(.ant-btn-background-ghost):not([disabled]) {\n  color: #ffffff;\n  background: #f97316;\n  border-color: #f97316;\n}\n\n.ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):hover,\n.ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):focus {\n  color: #ffffff;\n  background: #ea580c;\n  border-color: #ea580c;\n}\n\n.ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):active {\n  background: #c2410c;\n  border-color: #c2410c;\n}\n\n.ant-btn-primary[disabled],\n.ant-btn-primary[disabled]:hover,\n.ant-btn-primary[disabled]:focus {\n  color: #ffffff;\n  background: #fed7aa;\n  border-color: #fed7aa;\n}\n\n.ant-btn-dangerous.ant-btn-primary {\n  color: #ffffff;\n  background: #ef4444;\n  border-color: #ef4444;\n}\n\n.ant-btn-dangerous.ant-btn-primary:hover,\n.ant-btn-dangerous.ant-btn-primary:focus {\n  background: #dc2626;\n  border-color: #dc2626;\n}\n\n/* ---------- Inputs ---------- */\n.ant-input,\n.ant-input-affix-wrapper,\n.ant-picker,\n.ant-input-number,\n.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  border-color: #d6dee8;\n  border-radius: 8px;\n  box-shadow: 0 1px 2px 0 rgba(15, 23, 42, 0.04);\n}\n\n.ant-input:not(.ant-input-sm):not(.ant-input-lg):not(textarea) {\n  height: 36px;\n}\n\n.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-sm):not(.ant-input-affix-wrapper-lg):not(.ant-input-textarea-affix-wrapper) {\n  min-height: 36px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-sm):not(.ant-input-affix-wrapper-lg):not(.ant-input-textarea-affix-wrapper) > input.ant-input {\n  height: 34px;\n}\n\n.ant-picker:not(.ant-picker-small):not(.ant-picker-large) {\n  height: 36px;\n}\n\n.ant-input-number:not(.ant-input-number-sm):not(.ant-input-number-lg) {\n  height: 36px;\n}\n\n.ant-input-number:not(.ant-input-number-sm):not(.ant-input-number-lg) .ant-input-number-input {\n  height: 34px;\n}\n\n.ant-select:not(.ant-select-sm):not(.ant-select-lg):not(.ant-select-customize-input) .ant-select-selector {\n  min-height: 36px;\n}\n\n.ant-select-single:not(.ant-select-sm):not(.ant-select-lg):not(.ant-select-customize-input) .ant-select-selector {\n  height: 36px;\n}\n\n.ant-select-single:not(.ant-select-sm):not(.ant-select-lg) .ant-select-selection-item,\n.ant-select-single:not(.ant-select-sm):not(.ant-select-lg) .ant-select-selection-placeholder {\n  line-height: 34px;\n}\n\n.ant-select-single:not(.ant-select-sm):not(.ant-select-lg):not(.ant-select-customize-input) .ant-select-selection-search-input {\n  height: 34px;\n}\n\n.ant-input-search:not(.ant-input-search-small):not(.ant-input-search-large) .ant-input-search-button {\n  height: 36px;\n}\n\n.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child .ant-input-search-button {\n  border-radius: 0 8px 8px 0;\n}\n\n.ant-input::placeholder,\n.ant-input-affix-wrapper input::placeholder {\n  color: #94a3b8;\n}\n\n.ant-input:focus,\n.ant-input-focused,\n.ant-input-affix-wrapper:focus,\n.ant-input-affix-wrapper-focused,\n.ant-input-number-focused,\n.ant-picker-focused,\n.ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  border-color: #64748b;\n  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.2);\n}\n\n/* ---------- Cards ---------- */\n.ant-card {\n  border-radius: 12px;\n  box-shadow: 0 1px 2px 0 rgba(15, 23, 42, 0.05);\n}\n\n.ant-card-bordered {\n  border-color: #d6dee8;\n}\n\n.ant-card-head {\n  min-height: 52px;\n  border-bottom-color: #d6dee8;\n}\n\n.ant-card-head-title {\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: #0f172a;\n}\n\n.ant-statistic-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.ant-statistic-content {\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n}\n\n/* ---------- Tables ---------- */\n.ant-table {\n  color: #334155;\n}\n\n.ant-table-thead > tr > th {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: #64748b;\n  background: #fbfcfd;\n  border-bottom: 1px solid #d6dee8;\n}\n\n.ant-table-thead > tr > th::before {\n  display: none;\n}\n\n.ant-table-tbody > tr > td {\n  border-bottom: 1px solid #e9eef4;\n}\n\n.ant-table-bordered .ant-table-thead > tr > th,\n.ant-table-bordered .ant-table-tbody > tr > td,\n.ant-table-bordered .ant-table-container,\n.ant-table-bordered .ant-table-summary > tr > td {\n  border-color: #d6dee8;\n}\n\n.ant-table-small .ant-table-thead > tr > th,\n.ant-table-small .ant-table-tbody > tr > td {\n  padding: 10px 12px;\n}\n\n.ant-table-tbody > tr.ant-table-row:hover > td,\n.ant-table-tbody > tr > td.ant-table-cell-row-hover {\n  background: #f8fafc;\n}\n\n.ant-table-tbody > tr.ant-table-row-selected > td {\n  background: #e9eef4;\n}\n\n.ant-table-tbody > tr.ant-table-row-selected:hover > td {\n  background: #d6dee8;\n}\n\n.ant-table-container {\n  border-radius: 10px 10px 0 0;\n}\n\n/* ---------- Tags ---------- */\n.ant-tag {\n  padding: 0 8px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 20px;\n  border-radius: 4px;\n}\n\n.ant-tag:not([class*='ant-tag-']) {\n  color: #0f172a;\n  background: #d6dee8;\n  border-color: transparent;\n}\n\n.ant-tag-green,\n.ant-tag-success {\n  color: #15803d;\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n}\n\n.ant-tag-red,\n.ant-tag-error {\n  color: #b91c1c;\n  background: #fee2e2;\n  border-color: #fecaca;\n}\n\n.ant-tag-orange,\n.ant-tag-gold,\n.ant-tag-warning {\n  color: #c2410c;\n  background: #ffedd5;\n  border-color: #fed7aa;\n}\n\n.ant-tag-blue,\n.ant-tag-geekblue,\n.ant-tag-processing {\n  color: #0f172a;\n  background: #d6dee8;\n  border-color: transparent;\n}\n\n/* ---------- Alerts ---------- */\n.ant-alert {\n  border-radius: 8px;\n}\n\n.ant-alert-info {\n  color: #334155;\n  background: #fbfcfd;\n  border-color: #d6dee8;\n}\n\n.ant-alert-info .ant-alert-icon {\n  color: #1e293b;\n}\n\n.ant-alert-message {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n/* ---------- Dropdowns / select options ---------- */\n.ant-select-item-option-selected:not(.ant-select-item-option-disabled) {\n  font-weight: 600;\n  color: #0f172a;\n  background: #e9eef4;\n}\n\n.ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n  background: #f1f5f9;\n}\n\n.ant-dropdown-menu,\n.ant-select-dropdown,\n.ant-picker-dropdown .ant-picker-panel-container {\n  border-radius: 10px;\n  box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.1), 0 2px 4px -2px rgba(15, 23, 42, 0.1);\n}\n\n/* ---------- Pagination ---------- */\n.ant-pagination-item,\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link {\n  border-radius: 8px;\n}\n\n.ant-pagination-item-active {\n  background: #ffffff;\n  border-color: #1e293b;\n}\n\n.ant-pagination-item-active a {\n  color: #1e293b;\n}\n\n/* ---------- Modals ---------- */\n@media (min-width: 577px) {\n  .ant-modal:not(.ant-modal-confirm) {\n    min-width: 520px;\n    max-width: calc(100vw - 32px);\n  }\n}\n\n/* Outer ring instead of a border, and clip children to the rounded corners so a full-bleed\n   header leaves no light edge. */\n.ant-modal-content {\n  overflow: hidden;\n  background: #e9eef4;\n  border: 0;\n  border-radius: 12px;\n  box-shadow: 0 0 0 1px #d6dee8, 0 4px 6px -1px rgba(15, 23, 42, 0.1),\n    0 2px 4px -2px rgba(15, 23, 42, 0.1);\n}\n\n.ant-modal-header {\n  background: transparent;\n  border-bottom: 0;\n  border-radius: 12px 12px 0 0;\n}\n\n.ant-modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.ant-modal-body {\n  max-height: calc(100vh - 220px);\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.ant-modal-footer {\n  padding: 12px 24px 20px;\n  border-top: 0;\n}\n\n.ant-modal .ant-modal-footer .ant-btn:not(.ant-btn-sm):not(.ant-btn-lg),\n.ant-modal .ant-modal-confirm-btns .ant-btn:not(.ant-btn-sm):not(.ant-btn-lg) {\n  height: 40px;\n  padding: 0 24px;\n  font-weight: 500;\n  border-radius: 8px;\n}\n\n.ant-modal .ant-modal-footer .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]),\n.ant-modal .ant-modal-confirm-btns .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]) {\n  background: #1e293b;\n  border-color: #1e293b;\n}\n\n.ant-modal .ant-modal-footer .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):hover,\n.ant-modal .ant-modal-footer .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):focus,\n.ant-modal .ant-modal-confirm-btns .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):hover,\n.ant-modal .ant-modal-confirm-btns .ant-btn-primary:not(.ant-btn-dangerous):not(.ant-btn-background-ghost):not([disabled]):focus {\n  background: #334155;\n  border-color: #334155;\n}\n\n.ant-modal-confirm .ant-modal-content {\n  background: #ffffff;\n}\n\n/* Dark hero header (see ModalHeroComponent): the hero fills the header, so drop its padding. */\n.modal-dark-header .ant-modal-header {\n  padding: 0;\n  background: transparent;\n}\n\n.modal-dark-header .ant-modal-close {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.modal-dark-header .ant-modal-close:hover {\n  color: #ffffff;\n}\n\n.modal-dark-header .ant-modal-close-x {\n  width: 64px;\n  height: 64px;\n  line-height: 64px;\n}\n\n.modal-hero {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 24px 56px 24px 24px;\n  color: #ffffff;\n  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);\n}\n\n.modal-hero-icon {\n  display: flex;\n  padding: 12px;\n  font-size: 28px;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.modal-hero-title {\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.3px;\n}\n\n.modal-hero-subtitle {\n  margin-top: 2px;\n  font-size: 13px;\n  opacity: 0.85;\n}\n\n.modal-card {\n  padding: 24px;\n  background: #ffffff;\n  border: 1px solid #d6dee8;\n  border-radius: 12px;\n  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.03);\n}\n\n/* ---------- Drawer ---------- */\n.ant-drawer-content {\n  border-left: 1px solid #d6dee8;\n}\n\n.ant-drawer-header {\n  border-bottom-color: #d6dee8;\n}\n\n.ant-drawer-title {\n  font-weight: 600;\n  color: #0f172a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
